import { createElement, ForwardedRef, ReactNode } from 'react';
import * as motion from 'motion/react-client';
import { fadeInUp } from '@/animations';
import { AnimationProps } from './Box';
import classNames from 'classnames';

export interface ITextProps extends React.HTMLAttributes<HTMLElement>, AnimationProps {
  tag?: string;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
  className?: string;
  children?: ReactNode;
  ref?: ForwardedRef<HTMLElement>;
}

const Text = ({
  tag = 'div',
  animation = fadeInUp,
  animate = true,
  dangerouslySetInnerHTML,
  className,
  children,
  ...props
}: ITextProps) => {
  const _animate = animate && animation;
  const _motion = _animate ? animation : null;

  return createElement(
    _animate ? getMotionTag(tag) : tag,
    {
      ...props,
      ...(_animate ? _motion : {}),
      className: classNames(className, 'print:!opacity-100 print:!transform-none animation-text'),
      dangerouslySetInnerHTML,
    },
    children,
  );
};
const getMotionTag = (tag: string) => {
  const tags: { [key: string]: any } = {
    p: motion.p,
    h1: motion.h1,
    h2: motion.h2,
    h3: motion.h3,
    h4: motion.h4,
    h5: motion.h5,
    h6: motion.h6,
    span: motion.span,
    div: motion.div,
  };

  return tags[tag] || motion.div;
};

export default Text;
